import React, { Component, useState, useRef, useCallback } from 'react'
import { useMount } from 'react-use'
import { connect } from 'react-redux'
import Qr from 'qrcode.react'
import { sagaModal } from 'redux-saga-modal'
import { Tag, Checkbox, Table, Modal, Input, Divider, Upload, Icon, Button, message } from 'antd'
import _ from 'lodash'
import styles from './workerDialog.module.scss'
import { serviceInfo } from "@/utils/skill";


export default function SelectSkill({
  onChange,
  value
}) {
  const [selected, setSelected] = useState(value)
  const update = (category, fields = {}) => {
    const groupIdx = _.findIndex(selected, item => item.category === category)
    const group = groupIdx !== -1 ? Object.assign({}, selected[groupIdx]) : { category, items: [] }
    const finalData = selected.slice(0)

    for (const key in fields) {
      group[key] = fields[key]
    }

    if (groupIdx === -1) {
      finalData.push(group)
    } else {
      finalData[groupIdx] = group
    }

    setSelected(finalData)
    onChange(finalData)
  }
  const allCheck = (category) => e => {
    if (!e.target.checked) {
      return update(category, { items: [] })
    }

    const list = serviceInfo.find(item => item.category === category).items
    update(category, { items: list })
  }
  const selectService = (category, key) => e => {
    // if (!e.target.checked) {
    //   return update(category, {items: []})
    // }
  }
  const handleChange = (category, tag) => checked => {
    const groupIdx = _.findIndex(selected, item => item.category === category)
    const items = groupIdx !== -1 ? selected[groupIdx].items : []

    if (checked) {
      return update(category, { items: [...items, tag] })
    }

    const list = items.filter(item => tag !== item)
    update(category, { items: list })
  }

  return (
    <div>
      {
        serviceInfo.map(({ category, items }) => {
          const xselected = _.find(selected, item => item.category === category)
          const xx = xselected && xselected.items
          const services = (xselected && xselected.services) || {}
          return (
            <div key={category}>
              <div className={styles.skillGroupHeader}>
                <span className={styles.categoryTitle}>{category}(必填)</span>
                <div className={styles.allCheck}>
                  <Checkbox
                    checked={xx && xx.length && xx.length === items.length}
                    onChange={allCheck(category)}>全选</Checkbox>
                </div>
                {/* <div className={styles.checkService}>
                  <Checkbox
                    disabled
                    checked={services.installation}
                    onChange={selectService(category, 'installation')}>安装</Checkbox>
                  <Checkbox
                    disabled
                    checked={services.repair}
                    onChange={selectService(category, 'repair')}>维修</Checkbox>
                  <Checkbox
                    disabled
                    checked={services.delivery}
                    onChange={selectService(category, 'delivery')}>运输</Checkbox>
                </div> */}
              </div>
              <div className={styles.skillGroupItems}>
                {
                  items.map(tag => (
                    <Tag.CheckableTag
                      checked={xx && xx.includes(tag)}
                      onChange={handleChange(category, tag)}
                      key={tag}>
                      {tag}
                    </Tag.CheckableTag>
                  ))
                }
              </div>
            </div>
          )
        })
      }
    </div>
  )
}
